__turbopack_context__.v({
  "subtitle": "PageHeader-module__YBhL_G__subtitle",
  "title": "PageHeader-module__YBhL_G__title",
  "titleWrapper": "PageHeader-module__YBhL_G__titleWrapper",
  "wrapper": "PageHeader-module__YBhL_G__wrapper",
});
